import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
  InputAdornment,
  FormControl,
  Select,
  MenuItem,
  Chip,
} from "@mui/material";
import FooterPagination from "../Components/Include/FooterPagination";
import LoadingPage from "../Components/Include/LoadingPage";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
//Icons
import SearchIcon from "@mui/icons-material/Search";

import EmptyData from "../Components/Include/EmptyData";
import CreateIcon from "../Assets/create-icon.svg";
import { useQuery } from "@apollo/client";
import moment from "moment";
import { AuthContext } from "../Context/AuthContext";
import CreateReqTakeOut from "../Components/TakeOut/CreateReqTakeOut";
import { GET_TAKE_OUT_PAGINATION } from "../Schema/TakeOut";
import ReqTakeOutAction from "../Components/TakeOut/ReqTakeOutAction";
import { getInvoiceNo } from "../Function/FnKhmernumber";

export default function TakeOut() {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState(0);
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [status, setStatus] = useState("All");
  const [isVoidValue, setIsVoidValue] = useState("All");
  const [getTakeOutDate, setGetTakeOutDate] = useState("");

  // console.log("isVoidValusssssss", isVoidValue);
  // console.log("isVoidValusssssss", isVoidValue);
  const { refetch } = useQuery(GET_TAKE_OUT_PAGINATION, {
    variables: {
      page: 1,
      limit: 10,
      pagination: true,
      date: getTakeOutDate ? moment(getTakeOutDate).format("YYYY-MM-DD") : null,
      status: status,
      no: parseInt(keyword),
    },
    onCompleted: ({ getReqTakeOutPagination }) => {
      // console.log('getReqTakeOutPagination?.data', getReqTakeOutPagination?.data)
      setTableData(getReqTakeOutPagination?.data);
      setPaginationData(getReqTakeOutPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLoading(true);
    setLimit(e.target.value);
    setPage(1);
  };

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          {/* <Link className="page-link-title" to="/setting"> */}
          <Typography className="page-title">សំណើរប្រើប្រាស់</Typography>
          {/* </Link> */}
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ស្វែងរក</Typography>
            <TextField
              type="number"
              placeholder="ស្វែងរកឈ្មោះអ្នកប្រើប្រាស់"
              size="small"
              className="search-field"
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "black" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ស្ថានភាព</Typography>
            <FormControl className="search-field" fullWidth size="small">
              <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="All">ទាំងអស់</MenuItem>
                <MenuItem value="Approved">អនុម័ត</MenuItem>
                <MenuItem value="Rejected">បដិសេធ</MenuItem>
                <MenuItem value="Delivery">ដឹកជញ្ជូន</MenuItem>
                <MenuItem value="Received">ទទួល</MenuItem>
                <MenuItem value="Voided">មោឃៈ</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {/* <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">មោឃៈ</Typography>
            <FormControl className="search-field" fullWidth size="small">
              <Select
                value={isVoidValue}
                onChange={(e) => setIsVoidValue(e.target.value)}
              >
                <MenuItem value="All">ទាំងអស់</MenuItem>
                <MenuItem value={true}>បានធ្វើមោឃៈ</MenuItem>
                <MenuItem value={false}>មិនបានធ្វើមោឃៈ</MenuItem>
              </Select>
            </FormControl>
          </Grid> */}
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">កាលបរិច្ចេទ</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={getTakeOutDate}
                onChange={(newValue) => {
                  setGetTakeOutDate(newValue);
                }}
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                  },
                }}
                className="search-field"
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6} sm={6} md={12} lg={3} xl={4.8}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                បង្កើត
              </Button>
            </Stack>
            <CreateReqTakeOut
              dialogTitle="Create"
              open={open}
              handleClose={handleClose}
              setRefetch={refetch}
            />
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start" width="6%">
                ល.រ
              </TableCell>
              <TableCell className="header-title">កាលបរិច្ចេទ</TableCell>
              <TableCell className="header-title">ការិយាល័យ</TableCell>
              <TableCell className="header-title">អ្នកស្នើ</TableCell>
              <TableCell className="header-title" align="center">
                ស្ថានភាព
              </TableCell>
              <TableCell className="header-title">ផ្សេងៗ</TableCell>
              <TableCell className="header-title-end"></TableCell>
            </TableHead>

            {loading ? (
              <LoadingPage colSpan={7} />
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <EmptyData colSpan={7} />
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow className="body-row" key={index}>
                          <TableCell className="body-cell-start">
                            {/* {index + paginationData?.slNo} */}
                            {getInvoiceNo(row?.no)}
                          </TableCell>
                          <TableCell className="body-cell">
                            {moment(row?.createdAt).format(
                              "DD-MM-YYYY hh:mm A"
                            )}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.userId?.officeId?.officeKhName}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.userId?.mainUserId?.firstName +
                              " " +
                              row?.userId?.mainUserId?.lastName}
                          </TableCell>
                          <TableCell className="body-cell" align="center">
                            {row?.voidBy === null ? (
                              <Chip
                                size="small"
                                sx={{
                                  width: "80px",
                                  fontSize: "12px !important",
                                  color:
                                    row?.status === "Approved"
                                      ? "#4caf50"
                                      : row?.status === "Rejected"
                                        ? "#f44336"
                                        : row?.status === "Received"
                                          ? "#0091ea"
                                          : row?.status === "Pending"
                                            ? "#ffab40"
                                            : "#9c27b0",
                                  bgcolor:
                                    row?.status === "Approved"
                                      ? "#e8f5e9"
                                      : row?.status === "Rejected"
                                        ? "#ffebee"
                                        : row?.status === "Received"
                                          ? "#e1f5fe"
                                          : row?.status === "Pending"
                                            ? "#ffecb3"
                                            : "#f3e5f5",
                                }}
                                label={row?.status}
                              />
                            ) : (
                              <Chip
                                size="small"
                                label="Void"
                                sx={{
                                  width: "80px",
                                  fontSize: "12px !important",
                                  color: "red",
                                  bgcolor: "rgba(255, 0, 0, 0.1)", // Light red background
                                }}
                              />
                            )}

                            {/* <ButtonStatus editData={row} setRefetch={refetch} /> */}
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.remark}
                          </TableCell>

                          <TableCell className="body-cell-end" align="right">
                            <ReqTakeOutAction
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>

                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
        />
      </Box>
    </div>
  );
}
